import { put, call } from "redux-saga/effects";
import { SagaIterator } from "redux-saga";
import { fetchFilters } from "../../api/api";
import { fetchFiltersSuccess, fetchFiltersFailure } from "./filters";

export function* handleFetchFilters(): SagaIterator {
  try {
    const data = yield call(fetchFilters);
    yield put(fetchFiltersSuccess(data));
  } catch (error) {
    yield put(fetchFiltersFailure(error.message));
  }
}
